/**
 * Email logging utility for tracking email triggers and errors
 */

class EmailLogger {
  static log(type, message, data = {}) {
    const timestamp = new Date().toISOString();
    const logData = {
      timestamp,
      type,
      message,
      ...data
    };
    
    switch (type) {
      case 'trigger':
        console.log(`📧 EMAIL TRIGGER: ${message}`, logData);
        break;
      case 'success':
        console.log(`✅ EMAIL SUCCESS: ${message}`, logData);
        break;
      case 'error':
        console.error(`❌ EMAIL ERROR: ${message}`, logData);
        break;
      case 'fallback':
        console.log(`🔄 EMAIL FALLBACK: ${message}`, logData);
        break;
      case 'skip':
        console.log(`ℹ️ EMAIL SKIP: ${message}`, logData);
        break;
      case 'info':
        console.log(`📧 EMAIL INFO: ${message}`, logData);
        break;
      default:
        console.log(`📧 EMAIL: ${message}`, logData);
    }
    
    // Store in sessionStorage for debugging
    try {
      const existingLogs = JSON.parse(sessionStorage.getItem('emailLogs') || '[]');
      existingLogs.push(logData);
      // Keep only last 50 logs
      if (existingLogs.length > 50) {
        existingLogs.splice(0, existingLogs.length - 50);
      }
      sessionStorage.setItem('emailLogs', JSON.stringify(existingLogs));
    } catch (e) {
      // Ignore storage errors
    }
  }
  
  static trigger(message, data = {}) {
    this.log('trigger', message, data);
  }
  
  static success(message, data = {}) {
    this.log('success', message, data);
  }
  
  static error(message, data = {}) {
    this.log('error', message, data);
  }
  
  static fallback(message, data = {}) {
    this.log('fallback', message, data);
  }
  
  static skip(message, data = {}) {
    this.log('skip', message, data);
  }
  
  static info(message, data = {}) {
    this.log('info', message, data);
  }
  
  static getLogs() {
    try {
      return JSON.parse(sessionStorage.getItem('emailLogs') || '[]');
    } catch (e) {
      return [];
    }
  }
  
  static clearLogs() {
    try {
      sessionStorage.removeItem('emailLogs');
    } catch (e) {
      // Ignore storage errors
    }
  }
  
  static exportLogs() {
    const logs = this.getLogs();
    const blob = new Blob([JSON.stringify(logs, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `email-logs-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
}

// Add global access for debugging
if (typeof window !== 'undefined') {
  window.EmailLogger = EmailLogger;
  
  // Add console commands for easy debugging
  window.showEmailLogs = () => {
    const logs = EmailLogger.getLogs();
    console.table(logs);
    return logs;
  };
  
  window.clearEmailLogs = () => {
    EmailLogger.clearLogs();
    console.log('📧 Email logs cleared');
  };
  
  window.exportEmailLogs = () => {
    EmailLogger.exportLogs();
    console.log('📧 Email logs exported');
  };
  
  console.log('📧 Email debugging commands available:');
  console.log('  - showEmailLogs() - Display all email logs');
  console.log('  - clearEmailLogs() - Clear all email logs');
  console.log('  - exportEmailLogs() - Export logs to file');
}

export default EmailLogger;